import * as React from "react";
const SvgCamera = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.29 1.25A1.75 1.75 0 0 0 7.54 3v1c0 .698.409 1.3 1 1.582V7.25H2A1.75 1.75 0 0 0 .25 9v12c0 .966.784 1.75 1.75 1.75h20A1.75 1.75 0 0 0 23.75 21V9A1.75 1.75 0 0 0 22 7.25h-.102V6a1.75 1.75 0 0 0-1.75-1.75h-2A1.75 1.75 0 0 0 16.398 6v1.25H14.04V5.582c.591-.281 1-.884 1-1.582V3a1.75 1.75 0 0 0-1.75-1.75h-4Zm12.96 13V9a.25.25 0 0 0-.25-.25H2a.25.25 0 0 0-.25.25v5.25h5.053a5.251 5.251 0 0 1 10.394 0h5.053Zm-5.053 1.5h5.053V21a.25.25 0 0 1-.25.25H2a.25.25 0 0 1-.25-.25v-5.25h5.053a5.251 5.251 0 0 0 10.394 0ZM15.75 15a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0Zm2.148-7.75h2.5V6a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v1.25Zm-4.608-3h-4A.25.25 0 0 1 9.04 4V3a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25Zm-3.25 3v-1.5h2.5v1.5h-2.5Zm1.56 4.965a.75.75 0 0 0 0 1.5c.916 0 1.658.742 1.658 1.658a.75.75 0 0 0 1.5 0 3.158 3.158 0 0 0-3.158-3.158Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCamera;
